import HeroSection from '@/components/HeroSection'
import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'

export default function BlogPage() {
  const blogPosts = [
    {
      id: '1',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '2',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '3',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '4',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Business',
      likes: 32,
      comments: 8,
    },
    {
      id: '5',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Business',
      likes: 32,
      comments: 8,
    },
    {
      id: '6',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Business',
      likes: 32,
      comments: 8,
    },
  ]

  return (
    <>
      {/* Hero */}
      <HeroSection
        title="OUR BLOG"
        imageUrl="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop"
      />

      {/* Filter Section */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-4 mb-8">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Filter by date:</label>
              <select className="w-full px-4 py-2 bg-input border border-border rounded text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
                <option>mm/dd/yy</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Filter by Category:</label>
              <select className="w-full px-4 py-2 bg-input border border-border rounded text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
                <option>All Categories</option>
                <option>Travel</option>
                <option>Business</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Filter by Status:</label>
              <select className="w-full px-4 py-2 bg-input border border-border rounded text-foreground focus:outline-none focus:ring-2 focus:ring-accent">
                <option>All Status</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-center gap-2">
            <button className="p-2 hover:bg-secondary rounded transition-colors">
              <ChevronLeft size={20} />
            </button>
            {[1, 2, 3, 4, 10].map((page) => (
              <button
                key={page}
                className={`px-3 py-1 rounded transition-colors ${
                  page === 1
                    ? 'bg-accent text-accent-foreground'
                    : 'hover:bg-secondary text-foreground'
                }`}
              >
                {page}
              </button>
            ))}
            <button className="p-2 hover:bg-secondary rounded transition-colors">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <NewsletterSection />
    </>
  )
}
